import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin" && u.role !== "staff") {
        toast.error("Not an admin or staff account");
        setLoading(false);
        return;
      }
      toast.success(u.role === "admin" ? "Welcome back, Admin" : `Welcome, ${u.name}`);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md bg-white border border-[#2D2622]/10 rounded-2xl p-8 shadow-sm fade-up">
        <p className="overline">Master admin / staff</p>
        <h1 className="font-heading font-bold text-3xl text-[#2D2622] mt-2">Sign in</h1>
        <p className="text-[#5C5753] mt-2 text-sm">Big Billion Food &amp; Beverages — admins manage everything, staff handles dispatch.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div><Label>Email</Label>
            <Input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></div>
          <div><Label>Password</Label>
            <Input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} /></div>
          <Button data-testid="admin-submit" type="submit" disabled={loading} className="w-full bg-[#2D2622] hover:bg-[#1a1612] text-white">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <p className="text-sm text-[#5C5753] mt-6 text-center">
          <Link to="/" className="text-[#C85A32] font-semibold hover:underline">← Back to brand selector</Link>
        </p>
      </div>
    </div>
  );
}
